export const PHYLLO_USERID = "PHYLLO_USERID";
export const PHYLLO_TOKEN = "PHYLLO_TOKEN";

export const PHYLLO_SYNC_SUCCESS_KEY = "SYNCED";
export const PHYLLO_PARTIAL_SYNC_KEY = "PARTIAL_SYNCED";
export const PHYLLO_SYNC_FAIL_KEY = "NOT_SYNCED";
export const PHYLLO_IN_PROGRESS_KEY = "IN_PROGRESS";
export const PHYLLO_SUPPORT_FAIL_KEY = "NOT_SUPPORTED";
export const PHYLLO_CONNECTED_KEY = "CONNECTED";
export const PHYLLO_SESSION_EXPIRED = "SESSION_EXPIRED";
export const PHYLLO_NOT_CONNECTED_KEY = "NOT_CONNECTED";

export const PHYLLO_IDENTITY_KEY = "identity";
export const PHYLLO_ENGAGEMENT_KEY = "engagement";
export const PHYLLO_INCOME_KEY = "income";
export const PHYLLO_POLLING_TIMEOUT = 900000;
export const PHYLLO_PUBLISH_READY_STATUS = "READY";
export const PHYLLO_PUBLISH_SUCCESS_STATUS = "SUCCESS";
export const PHYLLO_PUBLISH_FAILURE_STATUS = "FAILURE";
export const PHYLLO_PUBLISH_IN_PROGRESS_STATUS = "IN_PROGRESS";

export const POLL_INTERVAL = 15000;
export const POLL_DURARION = 900000; //15 mins
export const PUBLISH_PLATFORM_MEDIA_MAPPING = {
  YouTube: "video/*",
  TikTok: "video/mp4",
  Instagram: "image/jpeg,image/jpg,video/mp4,video/quicktime",
};
export const SUCCESS_MESSAGE_MAPPING = {
  YouTube: "",
  TikTok: "Your post is ready! Please approve it on your TikTok app",
  Instagram: "Post successfully published to feed!",
};
export const AUDIENCE_SUPPORTED_PLATFORMS = ["TikTok", "Instagram"];
